<template>
  <div v-if="showPlaceholder" class="grey lighten-2" style="width: 100%">
    <v-icon
      class="d-flex"
      color="grey lighten-1"
      :size="placeholderSize"
      :style="'height: ' + size + 'px'"
    >mdi-image-outline</v-icon>
  </div>
  <v-img v-else :src="imageSrc" :height="size" />
</template>
<script>
export default {
  name: 'ProductImage',
  props: {
    product: {
      type: Object,
      default: function () {
        return {};
      }
    },
    size: {
      type: Number,
      default: 240
    }
  },
  computed: {
    showPlaceholder: function () {
      if (this.product.variant) {
        return !this.product.variant.image;
      }
      return this.product.images?.length === 0;
    },
    imageSrc: function () {
      if (this.product.variant) {
        return this.product.variant.image.src;
      } else if (this.product.images.length > 0) {
        return this.product.images[0].src;
      }
      return '';
    },
    backgroundColor: function () {
      if (this.showPlaceholder) {
        return 'grey lighten-2';
      }
      return '';
    },
    placeholderSize: function () {
      return this.size * 0.5;
    }
  }
};
</script>
